import cx from 'classnames';
import { AlertType } from '@/models';
import { SvgIcon, Pill } from '@/components';
import { CompRiskLevel } from '@/api';

import styles from './AlertBadge.module.sass';

interface AlertBadgeProps {
  isTextOnly?: boolean;
  type: AlertType | CompRiskLevel;
  label?: string;
  className?: string;
}

const AlertBadge = ({
  isTextOnly,
  type,
  label,
  className,
}: AlertBadgeProps) => {
  const classes = cx(
    styles.alertBadge,
    styles[`alertBadge--${type}`],
    { [styles['is-text-only']]: isTextOnly },
    className,
  );

  const formattedType = type === 'na' ? 'N/A' : type;

  return (
    <Pill isRounded className={classes}>
      {type === 'severe' && '!'}
      <span className={styles.text}>{!!label ? label : formattedType}</span>
      {type === 'severe' && '!'}
    </Pill>
  );
};

export default AlertBadge;
